import { useSuspenseQuery } from '@apollo/client/react';

import { findManyCourseQuery } from '~/shared/graphql-queries/courses';

const getFindManyCourseQuery = () => ({
  query: findManyCourseQuery,
  notifyOnNetworkStatusChange: true,
});

export const useFindManyCourseQuery = ({ filter, limit }) => {
  const useQueryProps = useSuspenseQuery(findManyCourseQuery, {
    variables: {
      filter,
      limit,
      sort: '_ID_DESC',
    },
    notifyOnNetworkStatusChange: true,
  });
  const { loading, error, data } = useQueryProps;

  return {
    loading,
    error,
    data,
  };
};
